__turbopack_context__.v({
  "badge": "Notice-module__SmBo-W__badge",
  "bell": "Notice-module__SmBo-W__bell",
  "body": "Notice-module__SmBo-W__body",
  "button": "Notice-module__SmBo-W__button",
  "centre": "Notice-module__SmBo-W__centre",
  "dialog": "Notice-module__SmBo-W__dialog",
  "empty": "Notice-module__SmBo-W__empty",
  "emptyIcon": "Notice-module__SmBo-W__emptyIcon",
  "footer": "Notice-module__SmBo-W__footer",
  "header": "Notice-module__SmBo-W__header",
  "headerActions": "Notice-module__SmBo-W__headerActions",
  "heading": "Notice-module__SmBo-W__heading",
  "iconButton": "Notice-module__SmBo-W__iconButton",
  "meta": "Notice-module__SmBo-W__meta",
  "primary": "Notice-module__SmBo-W__primary",
  "row": "Notice-module__SmBo-W__row",
  "rowActions": "Notice-module__SmBo-W__rowActions",
  "rowBody": "Notice-module__SmBo-W__rowBody",
  "rowFooter": "Notice-module__SmBo-W__rowFooter",
  "rowTitle": "Notice-module__SmBo-W__rowTitle",
  "signature": "Notice-module__SmBo-W__signature",
  "toastDescription": "Notice-module__SmBo-W__toastDescription",
  "toastTitle": "Notice-module__SmBo-W__toastTitle",
  "updates": "Notice-module__SmBo-W__updates",
});
